export function getFirstDayOfTheWeek(locale) {
    const parts = locale?.match(/^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i);
    const [region, language] = [parts?.[4], parts?.[1]];
    const regionSat = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g);
    const regionSun = 'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(/../g);
    const languageSat = ['ar', 'arq', 'arz', 'fa'];
    const languageSun = 'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g);
    return region
        ? regionSun.indexOf(region) > -1
            ? 0
            : regionSat.indexOf(region) > -1
                ? 6
                : 1
        : languageSun.indexOf(language) > -1
            ? 0
            : languageSat.indexOf(language) > -1
                ? 6
                : 1;
}
export const getLocalTimezone = () => {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
};
//# sourceMappingURL=utils.js.map